import { forwardRef, type ComponentPropsWithoutRef, type ComponentRef } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';

import { twcn } from '@web/ui/core/utils';

const Dialog = DialogPrimitive.Root;
const DialogTitle = DialogPrimitive.Title;

const DialogContent = forwardRef<
  ComponentRef<typeof DialogPrimitive.Content>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(function DialogContent({ className, children, ...props }, ref) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-modal bg-foreground/30 backdrop-blur-sm animate-scrim-in" />
      <DialogPrimitive.Content
        ref={ref}
        className={twcn(
          'fixed left-1/2 top-1/2 z-modal w-full max-w-md -translate-x-1/2 -translate-y-1/2',
          // Centrado com translate, o que passa da janela sai pelas duas pontas: limita e rola.
          'max-h-[calc(100dvh-2rem)] overflow-y-auto',
          'flex flex-col gap-4 rounded-lg border border-border-soft bg-surface p-6 shadow-overlay',
          'focus:outline-none',
          className,
        )}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
});

export { Dialog, DialogContent, DialogTitle };
